export const environment = {
  production: true,
  serverHost: 'https://api.global.qform.link/v1/',
  ssoHost: 'https://sso.qform.link/v1/',
  GTM_ID: '',
  version: 1.1
};
